module.exports = __webpack_public_path__ + "img/bg-logo.4827fd8f.png";